export enum LeadsCategoriesActionTypeEnum {
    REDIRECT = 1,
    INFORMATIVE = 2
}